/* unplugin-vue-components disabled */import script from "./TopicDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopicDetail.vue?vue&type=script&lang=ts&setup=true"

import "./TopicDetail.vue?vue&type=style&index=0&id=37db5666&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37db5666"]])

export default __exports__